function ft_cssVar(name: string) {
	if (name[0] !== '-')
		name = `--${name}`;
	return getComputedStyle(document.documentElement).getPropertyValue(name);
}

export default ft_cssVar;